module.exports = __webpack_public_path__ + "static/media/mechanical_eng_explain.007144db.jpg";